module.exports = __webpack_public_path__ + "img/banner3.09add538.jpg";